import React, { type FC } from 'react'

import { useIntl } from 'react-intl'

import { MESSAGE_BOX_VARIANT_HELP, MessageBox } from 'mailup-web-components'

const Info: FC = () => {
  const intl = useIntl()

  return (
    <MessageBox variant={MESSAGE_BOX_VARIANT_HELP}>
      {intl.formatMessage({ id: 'Load.GroupsList.GroupsInfo' })}
    </MessageBox>
  )
}

export default Info
